import React from 'react';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { SwapHoriz } from '@mui/icons-material';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { useTranslation } from 'react-i18next';
import CircularProgress from '@mui/material/CircularProgress';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

function SimpleBarChart({
  title,
  data,
  headerActionCallback,
  isHorizontal = false,
  loading = true
}) {
  const { t } = useTranslation();
  const options = {
    plugins: {
      legend: {
        display: false
      }
    },
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        grid: {
          display: false
        },
        ticks: {
          color: '#5C6370',
          font: {
            size: 10
          }
        }
      },
      y: {
        border: { dash: [2, 2] },
        ticks: {
          color: '#5C6370',
          font: {
            size: 10
          }
        }
      }
    }
  };

  if (isHorizontal) {
    options.indexAxis = 'y';
    options.scales.x.position = 'top';
    options.scales.y.border = {};
    options.scales.x.border = { dash: [2, 2] };
    options.scales.x.grid.display = true;
    options.scales.y.grid = { display: false };
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: loading ? 'space-between' : 'unset',
        height: '100%',
        width: '100%'
      }}
    >
      <Box
        sx={{
          width: '100%',
          mb: 2,
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'flex-start'
        }}
      >
        {headerActionCallback ? (
          <SwapHoriz color="#9B959F" onClick={headerActionCallback} sx={{ cursor: 'pointer' }} />
        ) : null}
        <Typography
          color="#00010E"
          fontSize={20}
          fontWeight={600}
          fontFamily={'Mulish'}
          letterSpacing="0.01938em"
          lineHeight="22px"
          sx={{ ml: headerActionCallback ? '10px' : 0 }}
        >
          {title}
        </Typography>
      </Box>
      {loading ? (
        <CircularProgress
          size={120}
          sx={{ color: 'rgb(37, 140, 243)', m: 'auto' }}
          thickness={6}
          variant="indeterminate"
        />
      ) : (
        <Box sx={{ height: 216, width: '100%' }}>
          {data && Object.keys(data?.labels)?.length ? (
            <Bar data={data} options={options} />
          ) : (
            <Typography
              color="lightgrey"
              fontSize={20}
              fontWeight={600}
              fontFamily={'Mulish'}
              letterSpacing="0.01938em"
              lineHeight="22px"
              sx={{ ml: headerActionCallback ? '10px' : 0, mt: 10 }}
              textAlign={'center'}
            >
              {t('telemetry.noData')}
            </Typography>
          )}
        </Box>
      )}
    </Box>
  );
}

SimpleBarChart.propTypes = {
  data: PropTypes.any,
  headerActionCallback: PropTypes.func,
  title: PropTypes.string,
  isHorizontal: PropTypes.bool,
  loading: PropTypes.bool
};

export { SimpleBarChart };
